import { gql } from '@soundxyz/gql-string';
import { useInfiniteQuery, UsersThatRepostedDocument } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  query UsersThatReposted($input: QueryPostRepostedByInput!) {
    postRepostedBy(input: $input) {
      edges {
        node {
          id
          ...UserModalRow
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`);

export const useRepostedByUsers = ({ postId }: { postId: string }) => {
  const {
    orderedList: repostedByUsers,
    isLoadingNewPage: isLoading,
    loadMoreNextPage: loadMore,
  } = useInfiniteQuery(UsersThatRepostedDocument, {
    getNextPageParam({ data: { postRepostedBy } }) {
      return (
        postRepostedBy?.pageInfo.hasNextPage && {
          after: postRepostedBy.pageInfo.endCursor,
        }
      );
    },
    list({ postRepostedBy }) {
      return postRepostedBy.edges.map(edge => edge.node);
    },
    uniq({ id }) {
      return id;
    },
    filterQueryKey: {
      postId,
    },
    variables({ pageParam }) {
      return {
        input: {
          postId,
          pagination: {
            first: 20,
            after: pageParam?.after || null,
          },
        },
      };
    },
    staleTime: 0,
  });

  return {
    repostedByUsers,
    isLoading,
    loadMore,
  };
};
